import produce from 'immer';

import {
  ORDER_UPDATED,
  ORDER_RECEIVED,
  ORDERS_RECEIVED,
  ORDER_SET_ACTIVE,
  SESSION_AUTH_INVALID,
  ORDER_DOCUMENT_RECEIVED
} from 'constants/actions';

export var INITIAL_STATE = {
  items: [],
  orderError: null,
  activeOrder: null,
  ordersError: null,
  orderUpdated: null
};

export const orders = produce((draft, action) => {
  switch (action.type) {
    case SESSION_AUTH_INVALID:
      draft = INITIAL_STATE;
      return draft;

    case ORDER_SET_ACTIVE:
      draft.activeOrder = action.value;
      return draft;

    case ORDER_RECEIVED: {
      let index = draft.items.findIndex(({ id }) => id === action.value.id);

      ~index
        ? (draft.items[index] = { ...draft.items[index], ...action.value })
        : draft.items.push(action.value);

      return draft;
    }

    case ORDER_UPDATED: {
      draft.orderUpdated = Date.now();
      return draft;
    }

    case ORDER_DOCUMENT_RECEIVED: {
      let index = draft.items.findIndex(({ id }) => id === action.value.order_id);

      if (~index) {
         draft.items[index].documents = [
          ...draft.items[index].documents || [], 
          action.value 
        ];
      }

      return draft;
    }

    case ORDERS_RECEIVED:
      draft.items = action.value;
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default orders;
